<template>
	<card class="stretch-layout" xs-tile sm-tile>

		<loader v-if="!participationStore.authPermissions.is_initialized" class="h-full"/>
		<alert v-else-if="(participationStore.hasSensitiveTracking && participationStore.participation.private) && !participationStore.canViewSensitiveInformation"
			   class="h-full"
			   :content="t('text.participation.private')"/>
		<participation-map v-else :event="eventStore.event" :participation="participationStore.participation"
						   :highlight-safe-bounding="participationStore.hasSensitiveTracking"
						   :hide-safe-bounding="participationStore.hasSensitiveTracking && !participationStore.canViewSensitiveInformation"
						   :downloadable="participationStore.canViewSensitiveInformation">
			<template v-if="!participationStore.hasFinished" #footer>
				<card-text>
					{{ $t('view.events.participations.show.tracking.description', {event: eventStore.event.display_name, user: participationStore.participation.first_name}) }}
				</card-text>
			</template>
		</participation-map>

		<card-text v-if="participationStore.participation.result_info">
			<user-content :text="participationStore.participation.result_info" class="mb-16"/>
		</card-text>
	</card>
</template>

<script setup lang="ts">

import {useEventStore} from "../../../../../store/event";
import {useParticipationStore} from "../../../../../store/participation";

const eventStore = useEventStore();
const participationStore = useParticipationStore();
const {$echo, $web, $apiFetch, $downloadFile, $analytics, $date} = useNuxtApp();
const {t} = useI18n();

if (!participationStore.participation.participationClass || (!participationStore.participation.route && !participationStore.hasEnabledAppTracking && !participationStore.participation.participationClass.live_tracking_enabled)) {
	await navigateTo($web('events.participations.show.results', [eventStore.event._key, participationStore.participation._key]));
}

useMeta({
	title: eventStore.buildPageTitle(t('view.events.participations.show.tracking.title', {
		event: eventStore.event.display_name,
		user: participationStore.participation.display_name
	})) as string,
	description: t('view.events.participations.show.tracking.description', {
		event: eventStore.event.display_name,
		user: participationStore.participation.display_name
	}) as string,
	noIndex: true
})

</script>

